/* SPRINGART — Slider photos cartes produit (mobile uniquement) */
(function () {
  if (window.__sprCardSliderInit) return;
  window.__sprCardSliderInit = true;

  function initSlider(slider) {
    if (slider.hasAttribute('data-slider-init')) return;
    slider.setAttribute('data-slider-init', '');

    var track = slider.querySelector('.card-slider__track');
    var dots = slider.querySelectorAll('.card-slider__dot');

    if (track && dots.length > 1) {
      var ticking = false;
      track.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var index = Math.round(track.scrollLeft / track.clientWidth);
            dots.forEach(function (dot, i) {
              dot.classList.toggle('is-active', i === index);
            });
            ticking = false;
          });
        },
        { passive: true }
      );
    }

    /* Tap simple = ouverture de la fiche produit (un swipe ne déclenche pas de click) */
    slider.addEventListener('click', function () {
      var url = slider.getAttribute('data-url');
      if (url) window.location.href = url;
    });
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('[data-card-slider]:not([data-slider-init])')
      .forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Cartes injectées dynamiquement (filtres de collection, pagination, sections) */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  new MutationObserver(function () {
    initAll();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
